//   const token =

//   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTQzODg5NTIsImV4cCI6MTcxNDQ3NTM1MiwiaWF0IjoxNzE0Mzg4OTUyfQ.KgeibbxuX-bGdwTgk2xqC80vuiL4QZjsctR9-l6gTQg";
export const fetchIndicatorApi = async (
  selectedExchange,
  setActiveButton,
  SelectedDropdownOption,
  dispatch,
  authToken,
  selectedAnalytics
) => {
  dispatch({ type: "IS_LOADING", payload: true });

  dispatch({ type: "SET_ERROR", payload: null });
  let minCandle = [
    "OneMinute",
    "FiveMinute",
    "FifteenMinute",
    "ThirtyMinute",
    "OneHour",
  ];

  try {
    let position;
    if (minCandle.includes(setActiveButton)) {
      position = "intradayanalytics";
    } else {
      position = "eodanalytics";
    }
    const IndicatorApiForIntraday = `https://idart.ftconline.in/api/${position}/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${setActiveButton}`;
    const IndicatorApiForEOD = `https://idartsuat.com/api/eodanalytics/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${setActiveButton}`;

    const response = await fetch(
      selectedAnalytics === "intraday-analytics"
        ? IndicatorApiForIntraday
        : IndicatorApiForEOD,
      {
        headers: { Authorization: `Bearer ${authToken}` },
        // headers: { Authorization: `Bearer ${tokenForV2}`}
      }
    );
    let data = await response.json();
    if (response.ok) {
      dispatch({ type: "TICKER_NAME", payload: data.Data });
      dispatch({ type: "SET_ERROR", payload: null });
      dispatch({ type: "IS_LOADING", payload: false });
      // setIsLoading(false)
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "SET_ERROR", payload: "Error in Api" });
    dispatch({ type: "IS_LOADING", payload: false });
    //   setIsLoading(false)
  }
};

export const fetchrslClassic = async (
  selectedExchange,
  setActiveButton,
  SelectedDropdownOption,
  dispatch,
  authToken,
  selectedAnalytics
) => {
  dispatch({ type: "IS_LOADING", payload: true });

  let ClassicApiForIntraday = `https://idart.ftconline.in/api/eodanalytics/BulkData/PivotPoints/${selectedExchange}/${setActiveButton}/Classic`;
  let ClassicApiForEod = `https://idartsuat.com/api/eodanalytics/BulkData/PivotPoints/${selectedExchange}/${setActiveButton}/Classic`;

  try {
    let response = await fetch(
      selectedAnalytics === "intraday-analytics"
        ? ClassicApiForIntraday
        : ClassicApiForEod,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          // Authorization: `Bearer ${tokenForV2}`,
        },
      }
    );
    let data = await response.json();
    if (response.ok) {
      const values = Array.isArray(data[0].Values) ? data[0].Values : [];
      dispatch({ type: "RSLEVEL_CLASSIC", payload: values });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "IS_LOADING", payload: false });
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
export const fetchrslFibo = async (
  selectedExchange,
  setActiveButton,
  SelectedDropdownOption,
  dispatch,
  authToken,
  selectedAnalytics
) => {
  dispatch({ type: "IS_LOADING", payload: true });

  let FibonacciApiForIntraday = `https://idart.ftconline.in/api/eodanalytics/BulkData/PivotPoints/${selectedExchange}/${setActiveButton}/Fibonacci`;
  let FibonacciApiForEod = `https://idartsuat.com/api/eodanalytics/BulkData/PivotPoints/${selectedExchange}/${setActiveButton}/Fibonacci`;

  try {
    let response = await fetch(
      selectedAnalytics === "intraday-analytics"
        ? FibonacciApiForIntraday
        : FibonacciApiForEod,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          // Authorization: `Bearer ${tokenForV2}`
        },
      }
    );
    let data = await response.json();
    if (response.ok) {
      const values = Array.isArray(data[0].Values) ? data[0].Values : [];
      // setRSLevelFibo(values);
      dispatch({ type: "RSLEVEL_FIBO", payload: values });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "IS_LOADING", payload: false });
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};

export const fetchReturnsData = async (
  dispatch,
  selectedExchange,
  authToken,
  selectedAnalytics
) => {
  let ReturnsApiForIntraday = `https://idart.ftconline.in/api/eodanalytics/BulkData/Returns/${selectedExchange}`;
  let ReturnsApiForEod = `https://idartsuat.com/api/eodanalytics/BulkData/Returns/${selectedExchange}`;
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let response = await fetch(
      selectedAnalytics === "intraday-analytics"
        ? ReturnsApiForIntraday
        : ReturnsApiForEod,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          // Authorization: `Bearer ${tokenForV2}`,
        },
      }
    );
    let data = await response.json();
    if (response.ok) {
      // setReturns(data.Data)
      dispatch({ type: "SET_RETURNS", payload: data.Data });
    }
    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error(error);
    dispatch({ type: "IS_LOADING", payload: false });
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
// https://www.dartstech.com/api/eodanalytics/meanreversion/NSE

export const fetchMeanReversionData = async (
  dispatch,
  selectedExchange,
  authToken,
  selectedAnalytics
) => {
  let MeanReversionApiForEod = `https://www.dartstech.com/api/eodanalytics/meanreversion/${selectedExchange}`;
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let response = await fetch(MeanReversionApiForEod, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    let JsonData = await response.json();

    if (response.ok) {
      if (selectedExchange === "NSE") {
        dispatch({
          type: "MEAN_REVERSION",
          payload: JsonData?.data?.nseScrips,
        });
      } else if (selectedExchange === "BSE") {
        dispatch({
          type: "MEAN_REVERSION",
          payload: JsonData?.data?.bseScrips,
        });
      }
    }

    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error(error);
    dispatch({ type: "IS_LOADING", payload: false });
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
export const validateAuthToken = async (dispatch, authToken) => {
  let url = `https://idartsuat.com/api/eodanalytics/BulkData/ValidateToken`;
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    dispatch({ type: "IS_LOADING", payload: false });
    if (response.ok) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    dispatch({ type: "IS_LOADING", payload: false });
    return false;
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
